import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export function ColumnHeader({ column, children, className }) {
  // Handle case where column is not a react-table column object
  if (!column || typeof column.getCanSort !== 'function' || !column.getCanSort()) {
    return <div className={cn("text-xs", className)}>{children}</div>
  }

  // Get alignment from column meta or parent
  const alignment = column.columnDef?.meta?.className?.includes('text-right') ? 'justify-end' :
                    column.columnDef?.meta?.className?.includes('text-center') ? 'justify-center' :
                    'justify-start';

  return (
    <div className={cn("flex min-w-0 items-center space-x-2", alignment, className)}>
      <Button
        variant="ghost"
        size="sm"
        className="-ml-3 h-auto py-1 data-[state=open]:bg-accent text-xs whitespace-normal"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        <span className="min-w-0 text-xs whitespace-normal break-words leading-tight">
          {children}
        </span>
        {column.getIsSorted() === "desc" ? (
          <ArrowDown className="ml-2 h-4 w-4" />
        ) : column.getIsSorted() === "asc" ? (
          <ArrowUp className="ml-2 h-4 w-4" />
        ) : (
          <ArrowUpDown className="ml-2 h-4 w-4" />
        )}
      </Button>
    </div>
  )
}


